<template>
  <div class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto" id="popup-content"
    @click.self="closeEditModal">
    <div class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto">
      <div class="flex items-center justify-between">
        <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
          Edit Order
        </p>
        <button class="text-2xl text-[#353535] cursor-pointer outline-none focus:outline-none" type="button"
          @click="closeEditModal">
          <span class="mdi text-xl mdi-close"></span>
        </button>
      </div>
      <form @submit.prevent="submit">
        <div class="bg-white px-[12px] md:px-[24px] py-[32px] mt-[16px] rounded-[4px] w-full">
          <h2 class="font-bold text-[20px] leading-[20px] text-[#2463EB] w-full">
            Order # {{ order.orderNumber }}
          </h2>
          <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
            <label class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
              Order For
            </label>
            <input type="text" class="form-control-plaintext" :value="user.parent.name" />
          </div>
          <div class="mt-[40px] w-full">
            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full mb-[16px]">
              Delivery Address
            </h2>
            <div class="max-w-[600px] w-full">
              <textarea
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="{
                  'is-invalid': $v.order.deliveryAddress.$error,
                }" :readonly="isSubmitted" v-model.trim="$v.order.deliveryAddress.$model"></textarea>
              <span class="invalid-feedback" v-if="!$v.order.deliveryAddress.minLength">
                Delivery Address must have at least
                {{ $v.order.deliveryAddress.$params.minLength.min }}
                letters.
              </span>
            </div>
          </div>
          <div class="mt-[16px] w-full">
            <div class="flex items-center gap-[10px] max-w-max mt-[16px]" @click="toggleState = !toggleState">
              <button type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer focus:outline-none"
                role="switch" :aria-checked="toggleState" :class="{
                  'bg-[#2463eb]': toggleState,
                  'bg-[#E4E4E7]': !toggleState,
                }">
                <span aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5': toggleState,
                    'translate-x-0': !toggleState,
                  }"></span>
              </button>
              <span class="cursor-pointer">
                <span class="text-[#353535] text-[16px] font-normal leading-[20px]">
                  Additional Information
                </span>
              </span>
            </div>
          </div>
          <div v-if="showContact" class="flex gap-[10px] w-full mt-[16px]">
            <div class="w-full">
              <label class="text-[#353535] font-medium text-[14px] leading-[20px]">Contact Name</label>
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text" :readonly="isSubmitted" placeholder="Enter contact person name" :class="{
                    'is-invalid': $v.order.contact.name.$error,
                  }" v-model.trim="$v.order.contact.name.$model" />
                <span class="invalid-feedback" v-if="!$v.order.contact.name.minLength">
                  Name must have at least
                  {{ $v.order.contact.name.$params.minLength.min }}
                  letters.
                </span>
              </div>
            </div>
            <div class="w-full">
              <label class="text-[#353535] font-medium text-[14px] leading-[20px]">Contact Phone</label>
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="tel" placeholder="Enter phone number" :class="{
                    'is-invalid': $v.order.contact.phoneNumber.$error,
                  }" :readonly="isSubmitted" v-model.trim="$v.order.contact.phoneNumber.$model" />
                <span class="invalid-feedback" v-if="!$v.order.contact.phoneNumber.minLength">
                  Phone number is not valid
                </span>
              </div>
            </div>
            <div class="w-full">
              <label class="text-[#353535] font-medium text-[14px] leading-[20px]">Contact Email</label>
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="email" placeholder="Enter Email Address" :class="{
                    'is-invalid': $v.order.contact.email.$error,
                  }" :readonly="isSubmitted" v-model.trim="$v.order.contact.email.$model" />
                <span class="invalid-feedback" v-if="!$v.order.contact.email.minLength">
                  Email is not valid
                </span>
              </div>
            </div>
          </div>
          <div v-if="showSpecialInstructions">
            <div class="max-w-[600px] w-full mt-[16px]">
              <label class="text-[#353535] font-medium text-[14px] leading-[20px]">Special Instructions</label>
              <div>
                <textarea
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="{
                    'is-invalid': $v.order.specialInstructions.$error,
                  }" :readonly="isSubmitted" v-model.trim="$v.order.specialInstructions.$model"></textarea>
                <span class="invalid-feedback" v-if="!$v.order.specialInstructions.minLength">
                  Special instructions must be at least
                  {{ $v.order.specialInstructions.$params.minLength.min }}
                  characters.
                </span>
              </div>
            </div>
          </div>
          <div class="bg-white px-[12px] md:px-[24px] py-[32px] mt-[16px] rounded-[4px] w-full">
            <ViewPurchaseOrderDetail :items="addedItems" :isBusyModal="isBusyModal" :isBusy="isBusy"
              :disableEdit="isSubmitted" :confirmed="isConfirm" :draft="isDraft" :needsQuote="needsQuote"
              @onDeleteItem="onDeleteItemHandler" :close="closeEditModal" :submit="submit"
              :deletePurchaseOrder="deletePurchaseOrder" />
          </div>
          <div class="flex justify-end w-full mt-[16px]">
            <div v-if="needsQuote && addedItems.length > 0">
              <button :disabled="isBusy" type="button" @click="getQuote"
                class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full">
                <span v-if="isBusy">Generating Quote...</span>
                <span v-else>Update My Quote</span>
              </button>
            </div>
            <div v-if="!needsQuote && addedItems.length > 0"
              class="max-w-[500px] w-full flex items-center justify-end gap-[10px]">
              <button
                class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none max-w-max w-full"
                @click="closeEditModal">
                Cancel
              </button>
              <button v-if="isDraft" :disabled="isBusy" type="button" @click="deletePurchaseOrder"
                class="border-[1px] bg-[#7367f0] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full">
                <span v-if="isBusy">Busy...</span>
                <span v-else>Delete</span>
              </button>
              <button :disabled="isBusyModal" type="submit"
                class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full">
                <span v-if="isBusyModal">Busy...</span>
                <span v-else-if="!isSubmitted">Update Order</span>
                <span v-else>Withdraw PO</span>
              </button>
            </div>
          </div>
          <AddItem :products="manufacturerProducts" :filteredProducts="filteredProducts" @onItemAdded="onItemAddHandler"
            @onItemUpdated="onItemUpdatedHandler" @onCancel="onCancelHandler" :edit="itemEdit" :groupId="groupId" />
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { required, minLength, helpers, email } from "vuelidate/lib/validators";
import { helper } from "@/helper";
import ViewPurchaseOrderDetail from "../../components/PurchaseOrder/ViewPurchaseOrderDetail";
import AddItem from "../../components/PurchaseOrder/AddItem";

// eslint-disable-next-line no-useless-escape
const phone = helpers.regex("alpha", /^[0]\d{10}$|[\+]?[234]\d{12}$/);
export default {
  props: ["closeEditModal", "orderId"],
  components: {
    ViewPurchaseOrderDetail,
    AddItem,
  },
  data() {
    return {
      showContact: false,
      showSpecialInstructions: false,
      isBusy: false,
      isBusyModal: false,
      toggleState: false,
      addedItems: [],
      manufacturerProducts: [],
      filteredProducts: [],
      groupId: "",
      quotes: null,
      hasChanged: false,
      originalItems: [],
      order: {
        orderNumber: "",
        deliveryAddress: "",
        created: "",
        total: 0,
        contact: {
          name: "",
          phoneNumber: "",
          email: "",
        },
        specialInstructions: "",
        status: "",
      },
      itemEdit: null,
      isDeleting: false,
      withdrawLoading: false,
    };
  },
  validations: {
    order: {
      deliveryAddress: {
        required,
        minLength: minLength(3),
      },
      contact: {
        name: {
          minLength: minLength(3),
        },
        phoneNumber: {
          phone,
        },
        email: {
          email,
        },
      },
      specialInstructions: {
        minLength: minLength(5),
      },
    },
  },
  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
    isSubmitted: function () {
      return this.order.status === "submitted";
    },
    isConfirm: function () {
      return this.order.status === "confirmed";
    },
    isDraft: function () {
      return this.order.status === "draft";
    },
    subTotal() {
      let result = 0;
      this.addedItems.forEach((item) => {
        result += (item.price || 0) * item.quantity;
      });
      return this.formatMoney(result);
    },
    needsQuote() {
      return this.addedItems.length > 0 && this.addedItems.some(item => !item.price || item.price === 0);
    },
  },
  watch: {
    toggleState(newValue) {
      if (newValue) {
        this.showSpecialInstructions = true;
        this.showContact = true;
      } else {
        this.showSpecialInstructions = false;
        this.showContact = false;
      }
    },
    order: {
      handler() {
        if (this.initialized) {
          this.hasChanged = true;
        }
      },
      deep: true,
    },
  },
  created() {
    this.getPurchaseOrder();
  },
  mounted() {
    this.getGroup();
  },
  methods: {
    async getGroup() {
      this.isBusy = true;
      try {
        const response = await this.$http.get(
          `/Groups/getGroup/${this.user.parentId}`
        );
        if (response.ok) {
          this.groupId = response.body;
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.$toast.error("Failed to fetch group. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
    async getManufacturerProducts() {
      this.isBusyModal = true;
      try {
        const response = await this.$http.get(
          "/Products/getListNoPagingForManufacturer?active=true" +
          (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        );
        if (response.ok) {
          this.manufacturerProducts = this.filteredProducts = response.body;
          this.performFilter();
        }
        this.isBusyModal = false;
      } catch (error) {
        this.isBusyModal = false;
        this.$toast.error("Failed to fetch products. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
    performFilter() {
      this.addedItems.forEach((element) => {
        this.filteredProducts = this.filteredProducts.filter(
          (product) => product.id !== element.id
        );
      });
    },
    async getQuote() {
      if (this.addedItems.length === 0) {
        this.quotes = null;
        return;
      }
      try {
        const swanCodes = [1200000060, 1200000063, 1200000064, 1200000061, 1200000065, 1200009366];
        const itemCodes = this.addedItems.map(item => Number(item.productCode));
        const hasAllowed = itemCodes.some(code => swanCodes.includes(code));
        const hasOther = itemCodes.some(code => !swanCodes.includes(code));
        if (hasAllowed && hasOther) {
          this.$toast.error(
            `Cannot get Quote..... Order contains products with different pricing schemes. Please correct and try again`,
            {
              icon: true,
              rtl: false,
            }
          );
          this.gettingQuote = false;
          return;
        }
        this.isBusy = true;
        const payload = {
          orderNumber: this.order.orderNumber,
          deliveryAddress: this.order.deliveryAddress,
          details: this.addedItems.map(item => ({
            productCode: item.productCode,
            productTax: 0,
            quantity: item.quantity,
            id: item.id,
            price: 0,
            description: item.description,
          })),
          orderContact: this.order.contact,
          status: this.order.status,
          specialInstructions: this.order.specialInstructions,
          discountAmount: 0,
          customerTax: this.user.parent && this.user.parent.sapTaxClassification ? this.user.parent.sapTaxClassification : 0,
          distributorCode: this.user.parent && this.user.parent.code ? this.user.parent.code : "",
        };
        const response = await this.$http.post("/PurchaseOrders/getSapSalesQuote", payload);
        if (response.ok) {
          this.quotes = response.body;
          this.addedItems = this.addedItems.map(item => {
            const quotePrice = this.quotes && this.quotes.productPrices
              ? this.quotes.productPrices.find(p => p.productCode === item.productCode)
              : null;
            return {
              ...item,
              price: quotePrice ? quotePrice.amountPerQuantity : 0,
            };
          });
          if (!this.quotes || !this.quotes.productPrices || this.quotes.productPrices.length === 0) {
            this.$toast.error("No valid prices returned. Please try again.", {
              icon: true,
              rtl: false,
            });
          }
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.quotes = null;
        this.addedItems = this.addedItems.map(item => ({ ...item, price: 0 }));
        this.$toast.error("Failed to fetch prices. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
    onItemAddHandler(newItem) {
      this.hasChanged = true;
      const product = this.manufacturerProducts.find(
        (product) => product.id === newItem.productId
      );
      this.filteredProducts = this.filteredProducts.filter(
        (product) => product.id !== newItem.productId
      );
      this.prepareItem(product, newItem);
      this.quotes = null;
      this.addedItems = this.addedItems.map(item => ({ ...item, price: 0 }));
    },
    onItemUpdatedHandler(newItem) {
      this.hasChanged = true;
      this.filteredProducts = this.filteredProducts.filter(
        (product) => product.id !== newItem.productId
      );
      this.prepareUpdateItem(newItem);
      this.quotes = null;
      this.addedItems = this.addedItems.map(item => ({ ...item, price: 0 }));
    },
    prepareUpdateItem(newItem) {
      this.addedItems = this.addedItems.map(item => {
        if (item.id === newItem.productId) {
          return {
            ...item,
            quantity: newItem.quantity,
            price: 0,
          };
        }
        return item;
      });
      // eslint-disable-next-line no-undef
      $("#mod-item-add").modal("hide");
    },
    prepareItem(product, newItem) {
      const preparedItem = {
        quantity: newItem.quantity,
        description: `${product.name}`,
        price: 0,
        id: product.id,
        productCode: product.code,
        productCategory: product.category ? product.category.name : "",
      };
      this.addedItems.push(preparedItem);
      // eslint-disable-next-line no-undef
      $("#mod-item-add").modal("hide");
    },
    onDeleteItemHandler(id) {
      this.hasChanged = true;
      const product = this.manufacturerProducts.find(
        (product) => product.id === id
      );
      this.addedItems = this.addedItems.filter((item) => item.id !== id);
      this.filteredProducts.push(product);
      this.quotes = null;
      this.addedItems = this.addedItems.map(item => ({ ...item, price: 0 }));
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    async getPurchaseOrder() {
      this.isBusy = true;
      this.initialized = false;
      try {
        const response = await this.$http.get(
          "/PurchaseOrders/get/" + this.orderId
        );
        if (response.ok) {
          const orderData = response.body.purchaseOrder;
          this.order = {
            orderNumber: orderData.orderNumber,
            deliveryAddress: orderData.deliveryAddress,
            created: orderData.created,
            total: orderData.total,
            contact: {
              name: orderData.contact.name || "",
              phoneNumber: orderData.contact.phoneNumber || "",
              email: orderData.contact.emailAddress || "",
            },
            specialInstructions: orderData.specialInstructions || "",
            status: orderData.status,
          };

          this.addedItems = response.body.purchaseOrderDetails.map(element => ({
            quantity: element.quantity,
            description: element.description,
            price: orderData.status === 'draft' ? 0 : element.price,
            id: element.product.id,
            productCode: element.product.code,
            productCategory: element.product.category ? element.product.category.name : "",
          }));

          this.originalItems = JSON.parse(JSON.stringify(this.addedItems));
          await this.getManufacturerProducts();
          this.initialized = true;
          this.hasChanged = false;
          if (orderData.status === 'draft') {
            this.quotes = null;
          }
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.$toast.error("Failed to fetch order. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
    itemsChanged() {
      if (this.addedItems.length !== this.originalItems.length) {
        return true;
      }
      return this.addedItems.some((item, index) => {
        const original = this.originalItems[index];
        return (
          item.id !== original.id ||
          item.productCode !== original.productCode ||
          item.quantity !== original.quantity ||
          item.description !== original.description
        );
      });
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.addedItems.length === 0) {
        this.$toast.error("Order is empty. Please add items.", {
          icon: false,
          rtl: false,
        });
        return;
      }
      if (!this.hasChanged && !this.itemsChanged()) {
        this.$toast.info("Order was not edited.... No changes will be made to the order", { icon: true, rtl: false });
        setTimeout(() => {
          this.closeEditModal();
        }, 4000)
        return;
      }
      if (this.needsQuote) {
        return;
      }
      if (this.isSubmitted) {
        console.log(here)
        await this.switchPurchaseOrder();
        return;
      }
      try {
        console.log(not)
        this.isBusyModal = true;
        const data = {
          orderNumber: this.order.orderNumber,
          deliveryAddress: this.order.deliveryAddress,
          details: this.addedItems,
          status: "submitted",
          date: Date.now(),
          orderContact: this.order.contact,
          specialInstructions: this.order.specialInstructions,
          discountAmount: 0,
          sapQuoteNumber: this.quotes.quoteNumber,
        };
        const response = await this.$http.put(
          "/PurchaseOrders/update/" + this.orderId,
          data
        );
        if (response.ok) {
          this.$toast.success("Order successfully updated!", {
            icon: true,
            rtl: false,
          });
          this.closeEditModal();
        }
      } catch (error) {
        this.$toast.error("Failed to update order. Please try again.", {
          icon: true,
          rtl: false,
        });
      } finally {
        this.isBusyModal = false;
      }
    },
    async switchPurchaseOrder() {
      this.withdrawLoading = true;
      this.isBusy = true;
      try {
        const response = await this.$http.put(
          `/PurchaseOrders/updateStatus/${this.orderId}/withdrawn`
        );
        if (response.ok && response.status === 200) {
          this.$toast.success("Order successfully withdrawn!", {
            icon: true,
            rtl: false,
          });
          this.closeEditModal();
        }
      } catch (error) {
        this.$toast.error("Failed to withdraw order. Please try again.", {
          icon: true,
          rtl: false,
        });
      } finally {
        this.withdrawLoading = false;
        this.isBusy = false;
      }
    },
    async deletePurchaseOrder() {
      this.isBusy = true;
      this.isDeleting = true;
      try {
        const response = await this.$http.delete(
          "/PurchaseOrders/delete/" + this.orderId
        );
        if (response.ok && response.status === 200) {
          this.$toast.success("Order successfully deleted!", {
            icon: true,
            rtl: false,
          });
          this.closeEditModal();
        }
      } catch (error) {
        this.$toast.error("Failed to delete order. Please try again.", {
          icon: true,
          rtl: false,
        });
      } finally {
        this.isBusy = false;
        this.isDeleting = false;
      }
    },
    onCancelHandler() {
      this.itemEdit = null;
    },
  },
};
</script>